import { Auth } from 'aws-amplify';
class AmplifyHelper {
    static GetCurrentUser = async (): Promise<ICognitoUser | undefined> => {
        let user = undefined;
        try {
            user = await Auth.currentAuthenticatedUser() as ICognitoUser;
        } catch {

        }
        return user;
    }
}

export default AmplifyHelper;